import {
    DELETE_MEMBERSHIP_SCHEDULE_SUCCESS,
    FETCH_MEMBERSHIP_SCHEDULE,
    FETCH_MEMBERSHIP_SCHEDULE_FAILURE,
    FETCH_MEMBERSHIP_SCHEDULE_SUCCESS,
    FETCH_MEMBERSHIP_SCHEDULES,
    FETCH_MEMBERSHIP_SCHEDULES_FAILURE,
    FETCH_MEMBERSHIP_SCHEDULES_SUCCESS,
    SORT_DESC,
} from 'store/actions/types';

import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    field: 'name',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    offset: 0,
    order: SORT_DESC,
    page: 1,
    size: 24,
    total: 0,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_MEMBERSHIP_SCHEDULE:
        case FETCH_MEMBERSHIP_SCHEDULES:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_MEMBERSHIP_SCHEDULE_FAILURE:
        case FETCH_MEMBERSHIP_SCHEDULES_FAILURE:
            return Object.assign({}, state, {
                loading: false,
            });

        case FETCH_MEMBERSHIP_SCHEDULE_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.response.id]: action.response,
                }),
                ids: [
                    ...state.ids,
                    ...action.response.id,
                ],
                loading: false,
            });

        case FETCH_MEMBERSHIP_SCHEDULES_SUCCESS:
            // Converts the Array of results to an Object based on the id.
            const convertResultsToData = utils.mapToObject(action.response.results, (value) => {
                return value.id;
            });

            const newIds = action.response.results.map(function (result) {
                return result.id;
            });

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, convertResultsToData),
                ids: newIds,
                loading: false,
                offset: action.response.offset,
                size: action.response.size,
                total: parseInt(action.response.total, 10),
            });

        case DELETE_MEMBERSHIP_SCHEDULE_SUCCESS:
            const {
                id,
            } = action.payload;

            const deletedData = reducerHelper.removeItemFromObject(state.data, id);
            const deletedStateIds = reducerHelper.removeItemFromArrayOfStrings(state.ids, id);

            return Object.assign({}, state, {
                data: deletedData,
                ids: deletedStateIds,
                loading: false,
                total: state.total - 1,
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/membershipSchedulesReducer.js